<template>
  <div class="power-target">
      <!-- 排放物 -->
      <div class="powerTar-input">
        <table class="mytable" style="width:auto">
          <thead>
            <tr>
              <th style="width:200px">能源类别</th>
              <th>指标</th>
              <th>实际消耗</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="background:#203bd5;text-align:center">电力</td>
              <td>
                <el-input v-model="powerTarget" placeholder="请输入内容">
                  <template slot="suffix">万度</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="powerData" placeholder="请输入内容">
                  <template slot="suffix">万度</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td style="background:#203bd5;text-align:center">水</td>
              <td>
                <el-input v-model="waterTarget" placeholder="请输入内容">
                  <template slot="suffix">吨</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="waterData" placeholder="请输入内容">
                  <template slot="suffix">吨</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td style="background:#203bd5;text-align:center">燃气</td>
              <td>
                <el-input v-model="gasTarget" placeholder="请输入内容">
                  <template slot="suffix">万立方米</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="gasData" placeholder="请输入内容">
                  <template slot="suffix">万立方米</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td style="background:#203bd5;text-align:center">煤炭</td>
              <td>
                <el-input v-model="coalTarget" placeholder="请输入内容">
                  <template slot="suffix">吨</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="coalData" placeholder="请输入内容">
                  <template slot="suffix">吨</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td style="background:#203bd5;text-align:center">燃油</td>
              <td>
                <el-input v-model="fuelTarget" placeholder="请输入内容">
                  <template slot="suffix">吨</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="fuelData" placeholder="请输入内容">
                  <template slot="suffix">吨</template>
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="last-save">
        <el-button :loading="targetLoading" size="small" @click="saveTarget" type="primary">保存</el-button>
      </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      targetLoading:false,//加载状态
      linshiID:'',
      powerTarget:'',//电指标
      powerData:'',//电实际
      waterTarget:'',//水指标
      waterData:'',//水实际
      gasTarget:'',//气指标
      gasData:'',//气实际
      coalTarget:'',//煤指标
      coalData:'',//煤实际
      fuelTarget:'',//油指标
      fuelData:'',//油实际
    }
  },
  mounted(){
    this.getTargetData()
  },
  methods:{
    //保存数据
    saveTarget(){
      this.targetLoading = true;
      let obj = {
        powerTarget:this.powerTarget,
        powerData:this.powerData,
        waterTarget:this.waterTarget,
        waterData:this.waterData,
        gasTarget:this.gasTarget,
        gasData:this.gasData,
        coalTarget:this.coalTarget,
        coalData:this.coalData,
        fuelTarget:this.fuelTarget,
        fuelData:this.fuelData,
      }
      if(this.linshiID){
        obj.id = this.linshiID
      }
      apis.saveTarget(obj).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功')
          this.targetLoading = false;
        }else{
          this.$message.error(res.message);
          this.targetLoading = false;
        }
      })
    },
    //获取数据
    getTargetData(){
      apis.getTarget().then(res=>{
        if(res.code==10000){
          let _data = res.data.list[0]
          this.linshiID = _data.id
          this.powerTarget = _data.powerTarget
          this.powerData = _data.powerData
          this.waterTarget = _data.waterTarget
          this.waterData = _data.waterData
          this.gasTarget = _data.gasTarget
          this.gasData = _data.gasData
          this.coalTarget = _data.coalTarget
          this.coalData = _data.coalData
          this.fuelTarget = _data.fuelTarget
          this.fuelData = _data.fuelData
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.power-target{ padding-top: 10px;
  .last-save{ margin-top: 2rem;}
}
</style>